import React from 'react';
import _get from 'lodash/get';
import { Field, FieldAttributes } from 'formik';
import UncontrolledRadioGroup from '@minecraft.uncontrolled-radio-group';
import { setFieldValueAndTouched } from '@minecraft.utils';

type Props = {
  saveAsOption?: boolean;
  options: Array<{
    label: any;
    value: any;
    disabled?: boolean;
    labelComponent?: () => React.ReactNode;
  }>;
  defaultValue?: any;
  name: string;
  fieldQAId?: string;
  handleChange?: (value?: string) => void;
  hideCount?: boolean;
  radioGroupLabel: string;
};

/**
 * @deprecated This is an older component that does not use our standard form wrapper
 * to match the design system.
 *
 * If this component is used in application code, we want to replace it with a controlled
 * RadioGroupInput component instead
 *
 * use the RadioGroupInput
 * import { RadioGroupInput } from '@minecraft.molecules'
 *
 * <RadioGroupInput name="fieldName" label="Field Label" options={options} />
 */
const FormikUncontrolledRadioGroup = ({ options, defaultValue, field, form, handleChange, hideCount, ...props }) => (
  <UncontrolledRadioGroup
    hideCount={hideCount}
    options={options}
    name={field.name}
    defaultValue={defaultValue || _get(form.initialValues, field.name)}
    onChange={(_, value) => {
      setFieldValueAndTouched(field.name, value, form);

      handleChange?.(value);
    }}
    {...props}
  />
);

/**
 * @deprecated This is an older component that does not use our standard form wrapper
 * to match the design system.
 *
 * If this component is used in application code, we want to replace it with a controlled
 * RadioGroupInput component instead
 *
 * use the RadioGroupInput
 * import { RadioGroupInput } from '@minecraft.molecules'
 *
 * <RadioGroupInput name="fieldName" label="Field Label" options={options} />
 */
const FormikFieldUncontrolledRadioGroup = ({
  name,
  options,
  defaultValue,
  handleChange,
  ...restProps
}: FieldAttributes<Props>) => {
  return (
    <Field
      component={FormikUncontrolledRadioGroup}
      name={name}
      options={options}
      defaultValue={defaultValue}
      handleChange={handleChange}
      {...restProps}
    />
  );
};

export default FormikFieldUncontrolledRadioGroup;
